module.exports = __webpack_public_path__ + "img/client-8.jpg?24343ab9f3ff1c9570ae7c4c5dabd58d";